import { render, staticRenderFns } from "./GameSett.vue?vue&type=template&id=68ce67bc&scoped=true&"
import script from "./GameSett.vue?vue&type=script&lang=js&"
export * from "./GameSett.vue?vue&type=script&lang=js&"
import style0 from "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./GameSett.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameSett.vue?vue&type=style&index=2&id=68ce67bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce67bc",
  null
  
)

export default component.exports